import request  from "../utils/request";
import qs from "qs";
const stringify = qs.stringify;

// 验证本地token
export function member() {
  return request.get('web/user/basic',{ member:true });
}
// 账号密码登录
export function login(data) {
  return request.post('web/login/mobile',stringify(data));
}
export function code_login(data) {
  return request.post('login',stringify(data));
}

// 发送验证码
export function sendSms(data) {
  return request.post('web/login/sendSms',stringify(data));
}
// 修改密码发送验证码
export function resetPwdSms(data) {
  return request.post('web/login/resetPwdSms',stringify(data));
}
// 通过验证码修改密码
export function resetPwd(data) {
  return request.post('web/login/resetPwd',stringify(data));
}

export function gt(params) {
  return request.get( 'web/gt',params);
}

export function get(uri,params) {
  return request.get(uri,params);
}






// WEBPACK FOOTER //
// ./src/api/login.js